<template>
  <div class="plan_detail">
    <img :src="details[key]" alt="">
  </div>
</template>
<script>
export default {
  data() {
    return {

      detailsData: [],

      details: {
        ali: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/ali.png',
        diantao: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/diantao.png',
        jd: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/jd.png',
        kudi: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/kudi.png',
        lianjia: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/lianjia.png',
        sinian: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/sinian.png',
        taohuaji: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/taohuaji.png',
        tengxun: 'https://dam-static.isheji.com/qiye1.0/AIGC/planCase/details/tengxun.png'
      },
      key: ''
    }
  },
  created() {
    this.key = this.$route.query.id
  }
}
</script>
<style lang="scss" scoped>
.plan_detail {
  width: 100%;
  min-height: 100vh;
  text-align: center;
  background: #F8F8F8;
  padding: 20px 0 40px;

  img {
    width: 1200px;
    min-width: 1200px;
  }
}
</style>
